<template>
    <div id="initialinterstitial" class="initial-modal hide">
        <div class="modal-content">
            <h2 class="modal-title text-center mb-2">Are you a healthcare professional?</h2>
            <div class="buttons d-flex flex-column flex-lg-row">
                <a class="button-accept m-0" @click="acceptModal" href="javascript:void(0);">Yes, I am</a>
                <a class="button-deny m-0" href="http://www.jornaypm.com/">No, I am not</a>
            </div>
            <p class="copy text-center mb-0">
                The information on this site is intended for healthcare professionals in the United States and is not intended for the general public.
            </p>
        </div>
    </div>
</template>
<script>
export default {
    mounted() {
        let isAccepted = (localStorage.getItem('journayhcpmodalacepted') === 'true') || false;
        let element = document.getElementById("initialinterstitial");
        if (!isAccepted) {
            element.classList.remove("hide");
        }
    },
    methods: {
        acceptModal() {
            let element = document.getElementById("initialinterstitial");
            localStorage.setItem('journayhcpmodalacepted', 'true');
            element.classList.add("hide");
            this.$root.$emit('modal', 'accept')
        }
    }

}
</script>